export default __webpack_public_path__ + "static/New-Jersey-ed5c020206eb69ed5b0c392f563a60fe.webp";